import React from "react";
import ProductContent from "./ProductContent";
import { GetQueryParameter } from "../../Utilities/Url";
import { setSelectedProduct } from "../../Utilities/Product";

export interface IProductState {
}

export interface IProductProps {
  product: string;
}

export class Product extends React.Component<IProductProps, IProductState> {
  state = {

  };
  componentWillMount(): void {
    setSelectedProduct(this.props.product);
  }

  public render() {
    return <ProductContent />;
  }
}
